import TreeView from 'devextreme-react/tree-view';
import Sortable from 'devextreme-react/sortable';
import { CheckBox } from 'devextreme-react/check-box';
import React from 'react';
import '../Context/context.css';
//import LogoTA from '../../../../images/ta.png';
import LogoTA from '../../../../images/headerLogo.png';
import FetchData from '../../../Utils/FetchData';
import UpdateWorkplace from '../../WorkPlace/UpdateWorkplace';
import ExpandContext from '../../WorkPlace/ExpandContext';
import CollapseContext from '../../WorkPlace/CollapseContext';
import setContextTemplateIdAction from '../../../../actions/setContextTemplateIdAction'
import setContextConfigurationAction from '../../../../actions/setContextConfigurationAction'
import setRootContextID from '../../../../actions/setRootContextID'
import setActionisrootSelected from '../../../../actions/setActionisrootSelected'
import setActionMultiRootContextItems from '../../../../actions/setActionMultiRootContextItems'
import { setSelectedContextItemsAction, setSelectedContextId } from '../../../../actions/setSelectedContextItemsAction'
import setContextsExpandCollapse from '../../../../actions/setContextsExpandCollapse'
import setActionDashboardlist from '../../../../actions/setActionDashboardlist';
import SvgContextPanelCollapse from '../../../../iconComponents/ContextPanelCollapse';
import SvgContextPanelExpand from '../../../../iconComponents/ContextPanelExpand';
import Scrollable from 'devextreme/ui/scroll_view/ui.scrollable';  

import Ulylogo from '../../../Logo/logoUlyssesTaskView';


import { connect } from 'react-redux'
var marginTop = '0px'
var rename = require('deep-rename-keys');
var _ = require('underscore');
//thanassis mourselas user when context is expanded
var modal
var arraymulticontext = [];
var conteFullareaHeight
var overflow
var overflowX
var widthContext
var contextResponsiveHeight
class Context extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contextConfigs: null,
            currentContextIdx: 0,
            currentContexts: [],
            contextsearch: '',
            contextsearchResults: [],
            selectedOption: '',
            contextTemplate: '',
            checkBoxValue: undefined,
            selectedRoot: false,
            text: '',
            parentID: '',
            isRootselected: false
        };
        this.treeRef = React.createRef();
        this.treeRefMulti = React.createRef();
        this.handleChange = this.handleChange.bind(this);


        if (this.props.taskIdState !== undefined) {

         
            this.fetchContexts()

        }
        if (this.props.folderIdState !== undefined) {
            this.fetchFolderContexts()
        }
    }

    refresContext(e) {
        //localStorage.clear();
        localStorage.removeItem("Caching")


        this.fetchContexts()
        this.fetchFolderContexts()

    }
    componentDidUpdate(prevProps, prevState) {

        //this.onContextSelected()
        if (this.props.taskcontextExpandCollapse === false) {


            document.getElementById('contextArea').style.visibility = 'hidden';

        }
        if (this.props.taskcontextExpandCollapse === true) {

            document.getElementById('contextArea').style.visibility = 'visible';

        }
        if (prevProps.contextTemplateIdState !== this.props.contextTemplateIdState) {
            var newIdx = this.state.contextConfigs.contextTemplateInfos.findIndex(ct => ct.contextTemplate.id === this.props.contextTemplateIdState)

            this.setState({
                currentContextIdx: newIdx < 0 ? 0 : newIdx,
                contextsearchResults: [],
                contextsearch: ''
            })
        }
        if (prevProps.taskIdState !== this.props.taskIdState) {
          
            arraymulticontext = [];
            this.fetchContexts()
        }
        if (prevProps.folderIdState !== this.props.folderIdState) {
            this.fetchFolderContexts()
            this.changeContextTemplate = this.changeContextTemplate.bind(this);
        }
        if (prevState.currentContextIdx !== this.state.currentContextIdx) {
            this.setState({
                contextsearchResults: [],
                contextsearch: ''
            })
            this.maintainContextSelection()
            this.changeContextTemplate = this.changeContextTemplate.bind(this);
        }
        if (prevState.contextsearchResults !== this.state.contextsearchResults) {
            if (this.treeRef.current !== null) {
                this.treeRef.current.instance.repaint()
            }
            if (this.treeRefMulti.current !== null) {
                this.treeRefMulti.current.instance.repaint()
            }
        }
    }

    maintainContextSelection() {
     
     
        if (this.state.contextConfigs !== null && this.state.contextConfigs.contextCount > 0) {

            if (this.props.contextSelectionState !== undefined && this.props.contextSelectionState.length === 1) {

                var currCtx = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx]
                var structureRelationSelected = currCtx.contextStructuresAndRelations.find(sr => sr.bEntityId.toLowerCase() === this.props.contextSelectionState[0].beid)

                if (structureRelationSelected !== undefined) {
                    if (structureRelationSelected.contextStructure.clevel === 0) {
                        var treeItems = this.treeRef.current.instance.option("items")
                       
                        var item
                        if (treeItems[0].ID === "00000000-0000-0000-0000-000000000000") {
                          
                            item = treeItems[0].items.find(i => (i.id === undefined ? i.ID.toLowerCase() : i.id.toLowerCase()) === this.props.contextSelectionState[0].id)
                        } else {
                           
                            item = treeItems.find(i => (i.id === undefined ? i.ID.toLowerCase() : i.id.toLowerCase()) === this.props.contextSelectionState[0].id)
                        }
                        this.treeRef.current.instance.selectItem(item)
                        this.forceUpdate()
                    } else if (currCtx.contextTemplate.contextLogicId !== null) {

                        this.props.indicatorVisible(true)
                        FetchData('/api/RTFCW/GetFullContextUI/' + currCtx.contextTemplate.id + '/' + this.props.usedataState + '/' + this.props.taskIdState + '/' + this.props.contextSelectionState[0].parent + '/' + this.props.contextSelectionState[0].id, 'GET', null, this.props.cacheState)
                            .then((data) => {

                                currCtx.displayTree = data.data
                                this.setState({ contextConfigs: this.state.contextConfigs })
                                this.forceUpdate()

                                this.props.indicatorVisible(false)
                            }).catch(function (error) {
                                this.props.indicatorVisible(false)
                                if (error == "TOKEN_REFRESH_EXCEPTION") {
                                    alert('Your login session has expired, please log in again.')
                                    window.location.href = '/';
                                }
                            }.bind(this));
                    }
                } else {
                    this.props.contextSelectionSet(undefined)
                }
            } else {
                this.props.contextSelectionSet(undefined)
            }
        }
    }

    fetchContexts() {
      
        this.props.indicatorVisible(true)
        FetchData('/api/RTFCW/TaskFilteredContextInfoA_UI/' + this.props.taskIdState + '/' + this.props.usedataState, 'GET', null, this.props.cacheState)
            .then((data) => {
                var contextConfiguration = data.data
              
                this.props.contextConfigurationSet(contextConfiguration)
                for (var i = 0; i < contextConfiguration.contextCount; i++) {
                 
                    var currCtx = contextConfiguration.contextTemplateInfos[i]
                   
                    if (currCtx.contextTemplate.isRootSelected === true) {
                      
                        this.setState({ selectedRoot: currCtx.contextTemplate.isRootSelected})
                    }
                  
                    if (currCtx.rootContextItemsUI !== null) {
                      
                        currCtx.displayTree = this.processData(currCtx.rootContextItemsUI, currCtx, 0)
                    }
                    if (currCtx.rootContextItemsUI === null) { 
                      
                        currCtx.contextStructuresAndRelations.map((i) => {
                          
                            if (i.multiRootContentData !== null) {
                             
                                currCtx.displayTree = this.processDataMulticontext(i.multiRootContentData, i.bEntity.isRecursive, i.bEntity.primaryAttribute, i.bEntity.name, i.bEntity.id, currCtx, 0)

                            } 

                        })
                    }
                   
                    this.props.multiRootContextItemsSet(currCtx.multiRootContextItems)
                    if (currCtx.multiRootContextItems === true) {
                        marginTop = '20px'
                    }

                }

                var folderContexts = contextConfiguration.contextTemplateInfos.map((i) => {
                    return i.contextTemplate.id
                })
                var newIdx = 0
                if (this.props.contextTemplateIdState !== undefined) {
                    newIdx = contextConfiguration.contextTemplateInfos.findIndex(ct => ct.contextTemplate.id === this.props.contextTemplateIdState)
                }

                this.setState({
                    contextConfigs: contextConfiguration,
                    currentContexts: folderContexts,
                    currentContextIdx: newIdx < 0 ? 0 : newIdx,
                    contextsearchResults: [],
                    contextsearch: ''
                })

                this.maintainContextSelection()
                this.props.indicatorVisible(false)
            }).catch(function (error) {

                this.props.indicatorVisible(false)
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            }.bind(this));

    }

    fetchFolderContexts() {
        this.props.indicatorVisible(true)

      

        FetchData('/api/RTFCW/FolderContextTemplatesA/' + this.props.folderIdState + '/' + this.props.taskIdState, 'GET', null, this.props.cacheState)
            //FetchData('/api/RTFCW/FolderContextTemplatesA/' + this.props.folderIdState + '/' + this.props.taskIdState)
            .then((data) => {

                var folderContexts = data.data.map((i) => {
                    return i.id
                })
                var newIdx = 0

                if (this.props.contextTemplateIdState !== undefined && folderContexts.includes(this.props.contextTemplateIdState)) {

                    newIdx = this.state.contextConfigs.contextTemplateInfos.findIndex(ct => ct.contextTemplate.id === this.props.contextTemplateIdState)

                } else {

                    newIdx = this.state.contextConfigs.contextTemplateInfos.findIndex(ct => ct.contextTemplate.id === folderContexts[0])
                    this.props.contextTemplateIdSet(folderContexts[0])
                }

                this.setState({
                    currentContexts: folderContexts,
                    currentContextIdx: newIdx < 0 ? 0 : newIdx,
                    contextsearchResults: [],
                    contextsearch: ''
                })
                this.maintainContextSelection()
                this.props.indicatorVisible(false)
            }).catch(function (error) {
                this.props.indicatorVisible(false)
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            }.bind(this));
    }
    sortTree(tree) {
     
        try {
            for (var i = 0; i < tree.length; i++) {

                if (tree[i].items.length > 0) {

                    this.sortTree(tree[i].items)
                }
            }
            tree.sort(function (e1, e2) {
                return (e1.positioninbranch - e2.positioninbranch);
            });
        } catch (e) {
        }
    }
    processDataMulticontext(data, isRecursive, primaryAttribute, bName, bId, currCtx, cLevel) {
        //console.log('processDataMulticontext')
       
        
       
        var obj
        var objWithRoot = [];
        //if (isRecursive === true) {
           
           
           
        //    var idValue
        //    data.map(item => {
        //        if (item.idParent === null) {
        //            idValue = "true"
        //        }
        //        if (item.idParent === 0) {
        //            idValue = "false"
        //        }
        //    });
          
        //    if (currCtx !== undefined) {
               

        //        if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
        //            if (idValue === undefined) {
        //                console.log('edo?')
        //                data.forEach(e => {

        //                    var node = e
        //                    while (node.items !== undefined) {
        //                        console.log(node.items)
        //                        if (node.items.length > 0) {
        //                            node.selected = true
        //                            break;
        //                        }
        //                        node = node.items

        //                    }

        //                    node.icon = 'fa fa-arrowcontext';
        //                    node.clevel = 0


        //                })

        //                return data
        //            }
                   
        //        }
        //    }
           
        //    var convertvalue = primaryAttribute
          
        //    obj = rename(data, function (key) {
        //        if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';

        //        return key;
        //    });
          
        //    var nestcomponents
        //    var treeComponents
        //    if (idValue === "true") {
        //       // console.log('1')
        //        nestcomponents = (items, id = null, link = 'idParent') =>
        //            items
        //                .filter(item => item[link] === id)
        //                .map(item => ({ ...item, items: nestcomponents(items, item.id) }));
        //        treeComponents = nestcomponents(obj);

        //    } else if (idValue === "false") {
        //      // console.log('2')
        //        nestcomponents = (items, id = 0, link = 'idParent') =>
        //            items
        //                .filter(item => item[link] === id)
        //                .map(item => ({ ...item, items: nestcomponents(items, item.id) }));
        //        treeComponents = nestcomponents(obj);
               
        //    } else {
        //     //   console.log('3')
        //        treeComponents = obj;
        //    }
        //    //treeComponents = nestcomponents(obj);
        //    //console.log('treeComponents')
        //    //console.log(treeComponents)

          
        //    objWithRoot.push({
        //        expanded: false,
        //        ID: '00000000-0000-0000-0000-000000000000',
        //        text: bName,
        //        items: treeComponents,
        //        businessEntityId: bId
        //    })
        //    console.log('objWithRoot')
        //    console.log(objWithRoot)
        //    arraymulticontext.push({ context: objWithRoot })
         
           
        //    return objWithRoot
        //} else {
        //   // console.log('isrecursivefalse')
        //    if (currCtx !== undefined) {
               
        //        if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
        //          // console.log('mpika edo')
        //            data.forEach(e => {
        //                //console.log('e')
        //                //console.log(e)
        //                var node = e
        //                while (node.items !== undefined) {
        //                    //console.log(node.items)
        //                    if (node.items.length > 0) {
        //                        node.selected = true
        //                        break;
        //                    }
        //                    node = node.items

        //                }
                      
        //                node.icon = 'fa fa-arrowcontext';
        //                node.clevel= 0

                     
        //            })
                  
        //            return data
        //        }
        //    }
        //    var convertvalue = primaryAttribute
         
        //    obj = rename(data, function (key) {
        //        if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';

        //        return key;
        //    });
        //    //console.log('2obj')
        //    //console.log(obj)
        //    console.log('objWithRoot1')
        //    console.log(objWithRoot)
        //    objWithRoot.push({
        //        expanded: false,
        //        ID: '00000000-0000-0000-0000-000000000000',
        //        text: bName,
        //        items: obj,
        //        businessEntityId: bId
        //    })
        //    arraymulticontext.push({ context: objWithRoot })
        //    //console.log('2')
        //    //console.log(objWithRoot)

        //    return objWithRoot
        //}
     
         if (isRecursive === false) {

             if (currCtx !== undefined) {

                 if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
                    
                     data.forEach(e => {
                        
                         var node = e
                         while (node.items !== undefined) {
                            
                             if (node.items.length > 0) {
                                 node.selected = true
                                 break;
                             }
                             node = node.items

                         }

                         node.icon = 'fa fa-arrowcontext';
                         node.clevel = 0


                     })

                     return data
                 }
             }
             var convertvalue = primaryAttribute

             obj = rename(data, function (key) {
                 if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';

                 return key;
             });
            
             objWithRoot.push({
                 expanded: false,
                 ID: '00000000-0000-0000-0000-000000000000',
                 text: bName,
                 items: obj,
                 businessEntityId: bId
             })
             arraymulticontext.push({ context: objWithRoot })
            

             return objWithRoot

           
         } else {
             var idValue
             data.map(item => {
                 if (item.idParent === null) {
                     idValue = "true"
                 }
                 if (item.idParent === 0) {
                     idValue = "false"
                 }
             });

             if (currCtx !== undefined) {


                 if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
                     if (idValue === undefined) {
                        
                         data.forEach(e => {

                             var node = e
                             while (node.items !== undefined) {
                                
                                 if (node.items.length > 0) {
                                     node.selected = true
                                     break;
                                 }
                                 node = node.items

                             }

                             node.icon = 'fa fa-arrowcontext';
                             node.clevel = 0


                         })

                         return data
                     }

                 }
             }

             var convertvalue = primaryAttribute

             obj = rename(data, function (key) {
                 if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';

                 return key;
             });

             var nestcomponents
             var treeComponents
             if (idValue === "true") {
                 // console.log('1')
                 nestcomponents = (items, id = null, link = 'idParent') =>
                     items
                         .filter(item => item[link] === id)
                         .map(item => ({ ...item, items: nestcomponents(items, item.id) }));
                 treeComponents = nestcomponents(obj);

             } else if (idValue === "false") {
                 // console.log('2')
                 nestcomponents = (items, id = 0, link = 'idParent') =>
                     items
                         .filter(item => item[link] === id)
                         .map(item => ({ ...item, items: nestcomponents(items, item.id) }));
                 treeComponents = nestcomponents(obj);

             } else {
                 //   console.log('3')
                 treeComponents = obj;
             }
             //treeComponents = nestcomponents(obj);
             //console.log('treeComponents')
             //console.log(treeComponents)


             objWithRoot.push({
                 expanded: false,
                 ID: '00000000-0000-0000-0000-000000000000',
                 text: bName,
                 items: treeComponents,
                 businessEntityId: bId
             })
           
             arraymulticontext.push({ context: objWithRoot })


             return objWithRoot
           // console.log('isrecursivefalse')
          
        }
    }
    processData(data, currCtx, cLevel) {
        
        var structuresRelations = currCtx.contextStructuresAndRelations.find(csr => csr.contextStructure.clevel === cLevel)
        //console.log('structuresRelations')
        //console.log(structuresRelations)
        var ContextComponents = Object.keys(data).map(key => ({
            ...data[key].information,
        }));
      
   

        ContextComponents.map((e) => {
            if (e.LevelInTree === 0)
                //console.log('e.LevelInTree === 0')
                e.IDParent = null;
                e.PersistentTable = structuresRelations.bEntity.persistentTable;
                e.clevel = cLevel;
                e.bEntityId = structuresRelations.bEntityId;
        });
        
      
        var objtoLowerCase = rename(ContextComponents, function (key) {
            key.toLowerCase();
            if (key.toLowerCase() === 'positioninbranch') return 'positioninbranch';
            return key;
        });

        //TM(Thanassis Mourselas): iF TREE IS RECURSIVE ONLY FOR  treeComponents 
      
        var nestcomponents1 = (items, ID = null, link = 'IDParent') =>
            items
                .filter(item => item[link] === ID)
                .map(item => ({ ...item, items: nestcomponents1(items, item.ID) }));
        nestcomponents1(objtoLowerCase);

        var idValue
        objtoLowerCase.map(item => {
            if (item.IDParent === null) {
               
                idValue = "true"
            }
            if (item.IDParent === 0) {
             
                idValue = "false"
            }
        });

        var nestcomponents
        if (idValue === "true") {

            nestcomponents = (items, ID = null, link = 'IDParent') =>
                items
                    .filter(item => item[link] === ID)
                    .map(item => ({ ...item, items: nestcomponents(items, item.ID) }));
            nestcomponents(objtoLowerCase);
        } else {
            nestcomponents = (items, ID = 0, link = 'IDParent') =>
                items
                    .filter(item => item[link] === ID)
                    .map(item => ({ ...item, items: nestcomponents(items, item.ID) }));
            nestcomponents(objtoLowerCase);
        }
        let treeComponents = nestcomponents(objtoLowerCase);
      
       
        if (treeComponents.length === 0) {
            //console.log('treeComponents')
            //console.log(treeComponents)
            var sortedObjs
            var byposition

            if (structuresRelations.contextStructure.sort === 0) {
               // console.log('1')
                sortedObjs = _.sortBy(ContextComponents, structuresRelations.bEntity.primaryAttribute);

                for (var index = 0; index < sortedObjs.length; index++) {
                    sortedObjs.map((e) => {
                        e.PositioninBranch = index++;
                    });
                }

            } else if (structuresRelations.contextStructure.sort === 1) {
               // console.log('2')
                sortedObjs = _.sortBy(ContextComponents, structuresRelations.bEntity.primaryAttribute).reverse();
                for (var index = 0; index < sortedObjs.length; index++) {
                    sortedObjs.map((e) => {
                        e.PositioninBranch = index++;
                    });
                }
            } else {
               //console.log('3')
                for (var index = 0; index < ContextComponents.length; index++) {
                    ContextComponents.map((e) => {
                        e.PositioninBranch = index++;
                    });
                }
                byposition = ContextComponents.slice(0);
                byposition.sort(function (a, b) {
                    return a.PositioninBranch - b.PositioninBranch;
                });
              
            }
            //console.log('byposition')
            //console.log(byposition)
            var convertvalue = structuresRelations.bEntity.primaryAttribute
            var obj
            //console.log('convertvalue')
            //console.log(convertvalue)
            if (sortedObjs != undefined) {
               // console.log('sortedObjs != undefined')
                obj = rename(sortedObjs, function (key) {
                    if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';
                    return key;
                });
            } else {
                //console.log('sortedObjs != undefined ELSE')
                obj = rename(ContextComponents, function (key) {
                    if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';
                    return key;
                });
            }
            if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
              
                obj.forEach(e => {
                   
                    var node = e
                    while (node.items !== undefined) {
                        if (node.items.length > 0) {
                           
                            node.selected = false
                            break;
                        }
                        node = node.items

                    }
                    // node.selected = true;
                    node.icon = 'fa fa-arrowcontext';

                    //node.icon = 'message'
                })
            }

            return obj
        } else {
            //console.log('elseelseelseelseelseelseelseelse')
            var convertvalue = structuresRelations.bEntity.primaryAttribute

            var sortedObjs
            sortedObjs = rename(treeComponents, function (key) {
                if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';
                if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';
                return key;
            });

            var obj
           
            if (structuresRelations.bEntity.isRecursive == true) {
                if (structuresRelations.contextStructure.sort === -1) {
                    obj = sortedObjs.slice(0);
                    this.sortTree(obj)

                } else {
                    obj = _.sortBy(sortedObjs, 'text');
                }
            } else {
                obj = rename(treeComponents, function (key) {
                    if (key.toLowerCase() === convertvalue.toLowerCase()) return 'text';
                    return key;
                });
                obj = _.sortBy(obj, 'text');
            }
          
            if (currCtx.contextStructuresAndRelations.some(csr => csr.contextStructure.clevel === cLevel + 1)) {
                obj.forEach(e => {
                   
                    var node = e
                    while (node.items !== undefined) {
                        if (node.items.length > 0) {
                            break;
                        }
                        node = node.items

                    }
                    //node.icon = 'fa fa-arrowleft';
                    //node.icon = 'message'
                })
            }
            return obj
        }
    }

    changeContextTemplate(e) {

       
        this.props.contextTemplateIdSet(e.target.value)
        document.getElementById("myDropdownContext").classList.remove("show");
        this.setState({ selectedRoot: false })
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.state.currentContextIdx !== nextState.currentContextIdx) {
            //  console.log('8')
            return true
        }
        if (this.state.selectedRoot !== nextState.selectedRoot) {
            //console.log('2')
            return true
        }
        if (this.state.contextConfigs !== nextState.contextConfigs) {
            // console.log('1')
            return true
        }
        if (this.props.taskIdState !== nextProps.taskIdState) {
            //  console.log('2')
            return true
        }
        if (this.props.taskcontextExpandCollapse !== nextProps.taskcontextExpandCollapse) {
            //  console.log('3')
            return true
        }
        if (this.props.contextExpandCollapse !== nextProps.contextExpandCollapse) {
            // console.log('4')
            return true
        }

        if (this.props.contextTemplateIdState !== nextProps.contextTemplateIdState) {
            //  console.log('5')
            return true
        }
        if (this.props.folderIdState !== nextProps.folderIdState) {
            //  console.log('6')
            return true
        }
        if (this.state.currentContexts !== nextState.currentContexts) {
            //  console.log('7')
            return true
        }

        if (this.state.contextsearchResults !== nextState.contextsearchResults) {
            //  console.log('9')
            return true
        }
        if (this.state.contextsearch !== nextState.contextsearch) {
            //  console.log('10')
            return true
        }
        if (nextProps.themeState != this.props.themeState) {
            //   console.log('11')
            return true
        }
        if (this.state.contextTemplate !== nextState.contextTemplate) {
            //  console.log('12')
            return true
        }
        if (nextProps.cacheState != this.props.cacheState) {
            //  console.log('13')
            return true
        }
        if (this.state.checkBoxValue !== nextState.checkBoxValue) {
            //  console.log('14')
            return true
        }
        return false;
    }

    handleClick = () => {

        var currCtx = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx]
        if (currCtx.contextTemplate.contextLogicId === null) {
            modal = document.getElementById("contextSearchModal");
            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];
            // When the user clicks the button, open the modal 
            modal.style.display = "block";
            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }
            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        } else {

            FetchData('/api/RTFCW/PerformContextSearch/' + currCtx.contextTemplate.id + '/' + this.state.contextsearch.replace(/ /g, "+"), 'GET', null, this.props.cacheState)
                // FetchData('/api/RTFCW/PerformContextSearch/' + currCtx.contextTemplate.id + '/' + this.state.contextsearch.replace(/ /g, "+"))
                .then((data) => {
                  
                    this.setState({ contextsearchResults: data.data })
                }).catch(function (error) {
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                }.bind(this));
        }
    }

    handleChange(e) {
        this.setState({ contextsearch: e.target.value });
    }

    treeSearch(obj, term) {
       
        if (Array.isArray(obj)) {
            var j
            var end = []
            for (j = 0; j < obj.length; j++) {
                var ult = this.treeSearch(obj[j], term)
                if (ult != null) {
                    if (Array.isArray(ult)) {
                        end = end.concat(ult)
                    } else {
                        end.push(ult)
                    }
                }
            }
            return end
        }
        var own = null
        var objectId = obj.id
        var objectParentid = obj.parentID
        var objectBId = obj.businessEntityID
        if (objectId === undefined) {
            objectId = obj.ID
        }
        if (objectParentid === undefined) {
            objectParentid = obj.IDParent
        }
        if (objectBId === undefined) {
            objectBId = obj.bEntityId
        }
        if (obj.text.toLowerCase().includes(term)) {

            own = {
                id: objectId,
                text: obj.text,
                parentID: objectParentid,
                isMatch: 1,
                isParent: 0,
                beid: objectBId

            }
        }
        if (!obj.items) {
            return own
        }
        var i
        var ret = []
        if (own != null) {
            ret.push(own)
        }
        for (i = 0; i < obj.items.length; i++) {
            var res = this.treeSearch(obj.items[i], term)
            if (res != null) {
                if (Array.isArray(res)) {
                    ret = ret.concat(res)
                } else {
                    ret.push(res)
                }

            }
        }
        if (ret.length === 0) {
            return null
        }
        ret.push({
            id: objectId,
            text: obj.text,
            parentID: objectParentid,
            isMatch: 0,
            isParent: 1,
            beid: objectBId
        })
        return ret
    }

    handleClickOptionRadio = (e) => {
    
        this.props.indicatorVisible(true)
        var currCtx = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx]
        if (this.state.selectedOption === 'all') {
            FetchData('/api/RTFCW/GetFullContextUI/' + currCtx.contextTemplate.id + '/' + this.props.usedataState + '/' + this.props.taskIdState, 'GET', null, this.props.cacheState)
                //FetchData('/api/RTFCW/GetFullContextUI/' + currCtx.contextTemplate.id + '/' + this.props.usedataState + '/' + this.props.taskIdState)
                .then((data) => {
                    currCtx.displayTree = data.data
                    var searchResults = this.treeSearch(data.data, this.state.contextsearch.toLowerCase())
                    this.setState({
                        contextConfigs: this.state.contextConfigs,
                        contextsearchResults: searchResults
                    })
                    this.forceUpdate()
                    //}).catch(function (error) {
                    //    if (error == "TOKEN_REFRESH_EXCEPTION") {
                    //        alert('Your login session has expired, please log in again.')
                    //        window.location.href = '/';
                    //    }
                    //}.bind(this));
                    this.props.indicatorVisible(false)
                }).catch(function (error) {
                    this.props.indicatorVisible(false)
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                }.bind(this));
        } else {
            var searchResults = this.treeSearch(currCtx.displayTree, this.state.contextsearch.toLowerCase())
            this.setState({ contextsearchResults: searchResults })
        }
        modal = document.getElementById("contextSearchModal");
        modal.style.display = "none";
    }

    handleCloseModal(e) {
        modal = document.getElementById("contextSearchModal");
        modal.style.display = "none";
    }

    handleOptionChange = (changeEvent) => {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    }
 
    onContextSelected = e => {
       
        if (e.itemData.ID === '00000000-0000-0000-0000-000000000000' && e.itemData.selected === false) {
           
            this.props.rootSelectedSet(false)
          
            this.props.rootContextSet('00000000-0000-0000-0000-000000000000')
        } else {
            this.props.rootSelectedSet(true)
           
            this.props.rootContextSet(e.itemData.ID)
            this.setState({ parentID: e.itemData.parentID })
        }

        var items
        if (e.itemData.ID === '00000000-0000-0000-0000-000000000000') {
           
            this.props.rootContextSet('00000000-0000-0000-0000-000000000000')
            if (e.itemData.selected === true) {

                this.setState({ selectedRoot: true })

                e.itemData.items.map((i) => {
                    i.id = i.ID
                    i.beid = i.bEntityId

                })
                items = e.itemData.items

                this.findRootParent(e.itemData.items, null)

            } else {

                this.setState({ selectedRoot: false })

                items = undefined
            }

        } else {
          
          
            items = this.props.contextSelectionState
            if (e.node.parent !== undefined && e.node.parent !== null) {
                Object.assign(e.node.parent, { selected: true });
                this.setState({ text: e.node.parent.text })
            }
            var itemId = e.itemData.ID === undefined ? e.itemData.id : e.itemData.ID

            var businessEntityId = e.itemData.bEntityId === undefined ? e.itemData.businessEntityID : e.itemData.bEntityId
            var setId = false
            this.setState({ selectedRoot: false })
            if (e.component.option('selectionMode') === 'single') {
               
                if (e.itemData.selected) {
                    var rootParent = this.findRootParent(e.node, null)

                    var item = {
                        //id: itemId.toLowerCase(),
                        id: itemId,
                        beid: businessEntityId.toLowerCase(),
                        //beid: businessEntityId,
                        text: e.itemData.text,
                        parent: rootParent.parent,
                        root: rootParent.root,


                    }
                    items = [item]

                } else {
                    return
                }
            } else {
          
                if (e.itemData.selected) {
                    
                    var rootParent = this.findRootParent(e.node, null)

                    var item = {
                        id: itemId.toLowerCase(),
                       // beid: businessEntityId.toLowerCase(),
                        beid: businessEntityId,
                        text: e.itemData.text,
                        parent: rootParent.parent,
                        root: rootParent.root
                    }
                    if (items === undefined) {
                  
                        setId = true
                        items = [item]
                    } else {
                       
                       
                        if (items.some(item => item.id === itemId)) {

                            return
                        }
                        setId = true
                        items.push(item)                    
                    }
                } else {
                  
                    if (items !== undefined) {
                        items = items.filter(item => item.id !== itemId)

                        if (items.length === 0) {
                            items = undefined
                        }
                    }
                }
            }
        }
        return new Promise(resolve => {

            this.props.contextSelectionSet(items)
            if (setId) {
                
                this.props.contextSelectionIdSet(itemId)
            } else {
               
                this.props.contextSelectionIdSet(undefined)
            }
            return resolve(true)
        })
    }

    findRootParent(obj) {
        var objectId
        if (obj.itemData === undefined) {
            objectId = obj.ID
        } else {
            objectId = obj.itemData.ID
        }
        if (objectId === undefined) {
            if (obj.itemData === undefined) {
                objectId = obj.ID
            } else {
                objectId = obj.itemData.id
            }
        }
        if (obj.itemData === undefined) {
            var ret = {
                parent: objectId,
                root: objectId
            }
            return ret;
        } else {

            if (obj.parent === null || obj.parent.itemData.ID === '00000000-0000-0000-0000-000000000000') {
                var ret = {
                    parent: objectId,
                    root: objectId
                }
                return ret;
            }
        }
        if (obj.parent.parent === null) {
            var parentId = obj.parent.itemData.ID
            if (parentId === undefined) {
                parentId = obj.parent.itemData.id
            }
            var ret = {
                parent: parentId,
                root: parentId
            }
            return ret
        }

        if (obj.parent.parent.parent === null) {
            var parentId = obj.parent.itemData.ID
          
            if (parentId === undefined) {
                parentId = obj.parent.itemData.id
                
            }
            var rootId = obj.parent.parent.itemData.ID
          
            if (rootId === undefined || rootId === '00000000-0000-0000-0000-000000000000') {
                rootId = obj.parent.itemData.id
            }
            var ret = {
                parent: parentId,
                root: rootId
            }
           
            return ret
        }

        return this.findRootParent(obj.parent)
    }

    itemrender = (e) => {
        if (this.state.contextsearchResults.length > 0) {
            var obj = this.state.contextsearchResults.find(o => o.id.toLowerCase() === (e.itemData.id === undefined ? e.itemData.ID.toString().toLowerCase() : e.itemData.id.toString().toLowerCase()))
            if (obj != undefined) {
                if (obj.isParent === 1) {

                    e.itemElement.style.fontWeight = "bold"
                }
                if (obj.isMatch === 1) {
                    e.itemElement.style.color = "#0061A1"
                }
            }
        }
    }
    onContentReady(e) {
     
        const scrollWidget = Scrollable.getInstance(e.element.querySelector('.dx-scrollable'));
        scrollWidget.option('useNative', true);
    } 
    getNextLevel = e => {
       
        var structureAndRelation = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations.find(csr => csr.contextStructure.clevel === e.node.itemData.clevel + 1)

       
        if (structureAndRelation !== undefined) {
            var itemId = e.node.itemData.id
            if (itemId === undefined) {
               
                itemId = e.node.itemData.ID
            }
            if (structureAndRelation.relationX.relation.queryType === 2) {
               
                modal = document.getElementById("myModal");
                // Get the <span> element that closes the modal
                var span = document.getElementsByClassName("close")[0];
                // When the user clicks the button, open the modal 
                modal.style.display = "block";
                // When the user clicks on <span> (x), close the modal
                span.onclick = function () {
                    modal.style.display = "none";
                }
                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                }
                return
            }
            //this.props.indicatorVisible(true)
            FetchData('/api/RTFCW/FetchContextFilteredItemsFromRelationAndObjectIdA_UI/' + this.props.usedataState + '/' + structureAndRelation.contextStructure.id + '/' + structureAndRelation.relationX.relation.id + '/' + structureAndRelation.initialCatalogue + '/' + structureAndRelation.relationX.relation.queryType + '/' + itemId, 'GET', null, this.props.cacheState)
                //FetchData('/api/RTFCW/FetchContextFilteredItemsFromRelationAndObjectIdA_UI/' + this.props.usedataState + '/' + structureAndRelation.contextStructure.id + '/' + structureAndRelation.relationX.relation.id + '/' + structureAndRelation.initialCatalogue + '/' + structureAndRelation.relationX.relation.queryType + '/' + itemId)
                .then((data) => {
      
                    var currCtx = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx]
                   
                    if (e.element.id === 'selection-treeviewMulti') {
                   
                        var items = this.treeRefMulti.current.instance.option("items")

                        e.node.itemData.items = this.processData(data.data, currCtx, e.node.itemData.clevel + 1)

                        e.node.itemData.icon = ''

                        this.treeRefMulti.current.instance.option("items", items)

                        this.treeRefMulti.current.instance.expandItem(e.node.itemData)
                    } else {
                     
                        var items = this.treeRef.current.instance.option("items")

                        e.node.itemData.items = this.processData(data.data, currCtx, e.node.itemData.clevel + 1)

                        e.node.itemData.icon = ''

                        this.treeRef.current.instance.option("items", items)

                        this.treeRef.current.instance.expandItem(e.node.itemData)
                    }
                })
                .catch(function (error) {
                    //this.props.indicatorVisible(false)
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                }.bind(this));
        }
    }

    getItem(obj, itemData) {
        var res = obj.find(item => item === itemData)
        if (res !== undefined) {
            return res
        }
        return obj.forEach(item => {
            if (item.items !== undefined) {
                return this.getItem(item.items, itemData)
            }
        })
    }
    openDropdown = event => {

        document.getElementById("myDropdownContext").classList.toggle("show");

    }
    openContext = (e) => {
      //alert('openContext')
        var widthResolution = window.innerWidth
        this.props.actionDashboardlistset(undefined)
        //if (widthResolution >= 2156 && widthResolution <= 2401) {

        //    contextResponsiveHeight = '624px'

        //}
        //if (widthResolution >= 2135 && widthResolution <= 2145) {

        //    contextResponsiveHeight = '490px'

        //}
        //if (widthResolution >= 2101 && widthResolution <= 2134) {

        //    contextResponsiveHeight = '489px'

        //}
        //if (widthResolution >= 2001 && widthResolution <= 2100) {

        //    contextResponsiveHeight = '587px'

        //}
        //if (widthResolution >= 1830 && widthResolution <= 1920) {
        //    alert('mpika')
        //    contextResponsiveHeight = '383px'

        //}
        //if (widthResolution >= 1886 && widthResolution <= 1920) {
        //    alert('mpika1')
        //    contextResponsiveHeight = '383px'

        //}
        //if (widthResolution >= 1830 && widthResolution <= 1886) {

        //    contextResponsiveHeight = '457px'

        //}
        //if (widthResolution >= 1751 && widthResolution <= 1777) {

        //    contextResponsiveHeight = '279px'

        //}
        //if (widthResolution >= 1682 && widthResolution <= 1746) {

        //    contextResponsiveHeight = '293px'

        //}
        //if (widthResolution >= 1600 && widthResolution <= 1681) {

        //    contextResponsiveHeight = '359px'

        //}
        //console.log(widthResolution)

        this.props.actionDashboardlistset(undefined)
        document.getElementById('contextArea').style.marginTop = '0px';


        this.props.contextExpandCollapseSet(true)
        var myElements = document.querySelectorAll(".contextResponsive");
        if (widthResolution >= 2156 && widthResolution <= 2401) {

            //contextResponsiveHeight = '624px'
            for (var i = 0; i < myElements.length; i++) {
             
                myElements[i].style.height = "881px"
            }

        }
        if (widthResolution >= 2135 && widthResolution <= 2145) {

            //contextResponsiveHeight = '490px'
            for (var i = 0; i < myElements.length; i++) {
              
                myElements[i].style.height = "758px"
            }

        }
        if (widthResolution >= 2101 && widthResolution <= 2134) {

            //contextResponsiveHeight = '489px'
            for (var i = 0; i < myElements.length; i++) {
             
                myElements[i].style.height = "489px"
            }

        }
        if (widthResolution >= 2001 && widthResolution <= 2100) {

           // contextResponsiveHeight = '587px'
            for (var i = 0; i < myElements.length; i++) {
             
                myElements[i].style.height = "587px"
            }

        }
        if (widthResolution >= 1830 && widthResolution <= 1920) {

           // contextResponsiveHeight = '383px'
            for (var i = 0; i < myElements.length; i++) {
           
                myElements[i].style.height = "930px"
            }

        }
        if (widthResolution >= 1886 && widthResolution <= 1920) {

           /// contextResponsiveHeight = '383px'
            for (var i = 0; i < myElements.length; i++) {
             
                myElements[i].style.height = "930px"
            }

        }
        if (widthResolution >= 1830 && widthResolution <= 1886) {

           // contextResponsiveHeight = '457px'
            for (var i = 0; i < myElements.length; i++) {
           
                myElements[i].style.height = "457px"
            }

        }
        if (widthResolution >= 1751 && widthResolution <= 1777) {

           // contextResponsiveHeight = '279px'
            for (var i = 0; i < myElements.length; i++) {
           
                myElements[i].style.height = "574px"
            }

        }
        if (widthResolution >= 1682 && widthResolution <= 1746) {

           //contextResponsiveHeight = '293px'
            for (var i = 0; i < myElements.length; i++) {
            
                myElements[i].style.height = "597px"
            }

        }
        if (widthResolution >= 1600 && widthResolution <= 1681) {

           // contextResponsiveHeight = '359px'
            for (var i = 0; i < myElements.length; i++) {
          
                myElements[i].style.height = "500px"
            }

        }
        //if (widthResolution > 1921) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "350px"
        //    }
        //}
        //if (widthResolution > 1829 && widthResolution < 1921) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "383px"
        //    }
        //}
        //if (widthResolution > 1681 && widthResolution < 1777) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "270px"
        //    }
        //}
        //if (widthResolution > 1599 && widthResolution < 1681) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "215px"
        //    }
        //}
        //if (widthResolution > 1440 && widthResolution < 1601) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "160px"
        //    }
        //}
        //if (widthResolution > 1279 && widthResolution < 1441) {
        //    for (var i = 0; i < myElements.length; i++) {
        //        console.log(myElements[i])
        //        myElements[i].style.height = "170px"
        //    }
        //}
        //this.props.contextExpandCollapseSet(true)
    }
    closeContext = (e) => {
//alert('closeContext')
        var widthResolution = window.innerWidth
       
        this.props.actionDashboardlistset(undefined)
        var myElements = document.querySelectorAll(".contextResponsive");

        if (widthResolution > 1921) {
            for (var i = 0; i < myElements.length; i++) {
                
                myElements[i].style.height = "750px"
            }
        }
        if (widthResolution > 1829 && widthResolution < 1921) {
            for (var i = 0; i < myElements.length; i++) {
               
                myElements[i].style.height = "720px"
            }
        }
        if (widthResolution > 1601 && widthResolution < 1777) {
            for (var i = 0; i < myElements.length; i++) {
            
                myElements[i].style.height = "680px"
            }
        }
        if (widthResolution > 1440 && widthResolution < 1601) {
            for (var i = 0; i < myElements.length; i++) {
            
                myElements[i].style.height = "530px"
            }
        }
        if (widthResolution > 1279 && widthResolution < 1441) {
            for (var i = 0; i < myElements.length; i++) {
               
                myElements[i].style.height = "510px"
            }
        }


        if (widthResolution === 1600) {
            document.getElementById('contextArea').style.marginTop = '-380px';
        }
        else if (widthResolution === 1440) {
            document.getElementById('contextArea').style.marginTop = '-388px';

        }
        else if (widthResolution === 1536) {
            document.getElementById('contextArea').style.marginTop = '-388px';

        }
        else {
            document.getElementById('contextArea').style.marginTop = '-390px';
        }
       // overflow = 'none'
        this.props.contextExpandCollapseSet(false)

    }
    
    render() {
        const { detect } = require('detect-browser');
        const browser = detect();
        var widthResolution = window.innerWidth
     
        var paddingBottom
        if (this.props.contextConfig !== undefined) {
            if (browser.name === 'firefox') {
                if (this.props.contextConfig.contextCount > 1) {
                    paddingBottom = "65px"
                } else {
                    paddingBottom = "18px"
                }
               
            } else {
                if (this.props.contextConfig.contextCount > 1) {
                    paddingBottom = "55px"
                } else {
                    paddingBottom = "0px"
                }
            }
            
        }
        var contextStyles;
        if (this.props.themeState === false || this.props.themeState === undefined) {

            contextStyles = window.defaultTheme;

        } else {

            contextStyles = window.darkTheme;

        }
       
      
        
        if (arraymulticontext.length > 0) {
          
            conteFullareaHeight = 'auto'
            contextResponsiveHeight = '330px'
            overflow = 'scroll'
            overflowX = 'hidden'
            widthContext = '326px'
          
        } else {
           
            if (widthResolution >= 2156 && widthResolution <= 2401) {
               
                contextResponsiveHeight = '881px'

            }
            if (widthResolution >= 2135 && widthResolution <= 2145) {
               
                contextResponsiveHeight = '758px'

            }
            if (widthResolution >= 2101 && widthResolution <= 2134) {
                
                contextResponsiveHeight = '758px'

            }
            if (widthResolution >= 2001 && widthResolution <= 2100) {
            
                contextResponsiveHeight = '587px'
             
            }
            if (widthResolution >= 1830 && widthResolution <= 1920) {
             
                contextResponsiveHeight = '654px'

            }
            if (widthResolution >= 1886 && widthResolution <= 1920) {
                
                contextResponsiveHeight = '654px'

            }
            if (widthResolution >= 1830 && widthResolution <= 1886) {

                contextResponsiveHeight = '457px'

            }
            if (widthResolution >= 1751 && widthResolution <= 1777) {

                contextResponsiveHeight = '574px'

            }
            if (widthResolution >= 1682 && widthResolution <= 1746) {

                contextResponsiveHeight = '597px'

            }
            if (widthResolution >= 1600 && widthResolution <= 1681) {

                contextResponsiveHeight = '500px'

            }
            
            overflow = 'none'
        }
        var widthResolution = window.innerWidth
        var heightResolution = window.innerHeight
        var contextHeight
        if (widthResolution < 1921 && widthResolution > 1820) {
            if (this.state.contextConfigs !== null) {
                if (this.state.contextConfigs.contextCount > 1) {
                    contextHeight = '69%'
                } else {
                    contextHeight = '77%'
                }
            }

        }
        if (widthResolution < 1821 && widthResolution > 1774) {
            if (this.state.contextConfigs !== null) {
                if (this.state.contextConfigs.contextCount > 1) {
                    contextHeight = '60%'
                } else {
                    contextHeight = '71%'
                }
            }

        }
        if (widthResolution < 1774 && widthResolution > 1679) {
            if (this.state.contextConfigs !== null) {
                if (this.state.contextConfigs.contextCount > 1) {
                    contextHeight = '50%'
                } else {
                    contextHeight = '67%'
                }
            }

        }
        if (widthResolution < 1680 && widthResolution > 1599) {
            if (this.state.contextConfigs !== null) {
                if (this.state.contextConfigs.contextCount > 1) {
                    contextHeight = '50%'
                } else {
                    contextHeight = '67%'
                }
            }

        }

        var heightContext
      
        if (this.state.contextConfigs !== null) {
         
            if (this.state.contextConfigs.contextCount > 0) {
            
                var treeObject;
                var objWithRoot = [];
              
                var itemsMultiselection = [];
                var isrootSelected


                if (this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].contextStructure.allowRootSelection === true) {

                  
                    if (this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextTemplate.isRootSelected === true) {
                      
                      
                        this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree.map((items) => {
                           
                          
                         
                            var text = items.text
                            var id = items.ID
                            var bEntityId = items.bEntityId
                          

                            if (id === this.props.rootContextState) {
                               
                                itemsMultiselection.push({
                                    text: text,
                                    id: id,
                                    parent: id,
                                    root: id,
                                    beid: bEntityId,
                                    selected: false


                                })
                            } else {
                                //console.log('else -----------------------------------')
                                itemsMultiselection.push({
                                    text: text,
                                    id: id,
                                    parent: id,
                                    root: id,
                                    beid: bEntityId,
                                    selected: false


                                })
                                //console.log(itemsMultiselection)
                            }

                        })
                      
                        if (this.state.selectedRoot === true  ) {
                            isrootSelected = true
                            this.props.rootSelectedSet(isrootSelected)
                        } else {
                            isrootSelected = false
                            this.props.rootSelectedSet(isrootSelected)
                        }
                      
                        this.props.contextSelectionSet(itemsMultiselection)

                    } else {
                       //console.log('else')
                        //if (arraymulticontext.length > 0) {
                          
                        //    this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree.map((items) => {

                        //        var text = items.text
                        //        var id = items.ID
                        //        var bEntityId = items.bEntityId

                        //        itemsMultiselection.push({
                        //            text: text,
                        //            id: id,
                        //            parent: id,
                        //            root: id,
                        //            beid: bEntityId,
                        //            selected: true


                        //        })
                        //    })

                        //    this.props.contextSelectionSet(itemsMultiselection)
                        //    isrootSelected = true
                        //    this.props.rootSelectedSet(isrootSelected)
                        //}
                        //console.log(this.state.selectedRoot)
                        if (this.state.selectedRoot === true) {
                            //console.log('3')
                            //console.log(this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree)
                            this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree.map((items) => {

                                var text = items.text
                                var id = items.ID
                                var bEntityId = items.bEntityId

                                itemsMultiselection.push({
                                    text: text,
                                    id: id,
                                    parent: id,
                                    root: id,
                                    beid: bEntityId,
                                    selected: true


                                })
                            })

                            this.props.contextSelectionSet(itemsMultiselection)
                            isrootSelected = true
                            this.props.rootSelectedSet(isrootSelected)
                        } else {
                            //console.log('4')
                            isrootSelected = false
                            this.props.rootSelectedSet(isrootSelected)
                        }
                    }

                 
                    objWithRoot.push({
                        expanded: true,
                        ID: '00000000-0000-0000-0000-000000000000',
                        text: this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].bEntity.name,
                        items: this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree,

                        selected: isrootSelected,

                        businessEntityId: this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].bEntity.id
                    })
                
                    //this.props.rootContextSet('00000000-0000-0000-0000-000000000000')
                    treeObject = objWithRoot
                    

                } else {
                    isrootSelected = false
                    this.props.rootSelectedSet(isrootSelected)

                    treeObject = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree
                }

                var selectedContext = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx]
               
                var rootSelectedId;
              
                var structureRelationSelectedDoubleContext = this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations.find(sr1 => sr1.contextStructure.contextTemplateId === this.props.contextTemplateIdState)
              
                if (structureRelationSelectedDoubleContext != undefined) {
                 
                    if (structureRelationSelectedDoubleContext.multiRootContentData === null) {
                        arraymulticontext = []
                    } else {
                        arraymulticontext = []
                        this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations.map((i) => {
                         
                            if (i.multiRootContentData !== null) {

                                this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree = this.processDataMulticontext(i.multiRootContentData, i.bEntity.isRecursive, i.bEntity.primaryAttribute, i.bEntity.name, i.bEntity.id)
                              
                            }
                        })
                    }
                  
                }
               
                var options = this.state.contextConfigs.contextTemplateInfos.map((item, index) => {
                  
                    if (item.contextTemplate.isRootSelected === true) {
                      
                        rootSelectedId = item.contextTemplate.id
                    }

                    var test
                    if (item.contextTemplate.id !== selectedContext.contextTemplate.id && this.state.currentContexts.some(i => i === item.contextTemplate.id)) {
                     
                       
                        return <option onClick={this.changeContextTemplate.bind(this)} value={item.contextTemplate.id} key={index}>{item.contextTemplate.name}</option>
                    }

                })
                options = options.filter(o => o !== undefined)
                if (selectedContext !== undefined) {

                  
                    options.unshift(<option onClick={this.changeContextTemplate.bind(this)} value={selectedContext.contextTemplate.id}>{selectedContext.contextTemplate.name}</option>)

                }
            }
          
          
        }
        
        return (

            <div style={{ height:'800px', border: '0px solid #111', overflow: 'auto', overflowX: 'hidden' }} id="contextArea" >
                <div>
                    <div id="contextSearchModal" class="modal">
                        <div className="modal-content">
                            <span className="close">&times;</span>
                            <p><img style={{ marginTop: '0px', verticalAlign: 'bottom' }} src={LogoTA} /></p>
                            <h3 style={{ borderBottom: '0px', height: '28px' }}>You are attempting to search context within which some items are not loaded</h3>
                            <h3 style={{ borderBottom: '0px', height: '28px' }}>For a complete search, it is necessary to load all items within the search space</h3>
                            <h3 style={{ borderBottom: '0px', height: '28px' }}>NOTE: The loading of all items make take some time for large search spaces</h3>
                            <div className="radio">
                                <label><input type="radio" name="searchcontext" value="all" onChange={this.handleOptionChange} />Load all items and search the context<span></span></label>
                            </div>
                            <div className="radio">
                                <label><input type="radio" name="searchcontext" value="notall" onChange={this.handleOptionChange} />Search throught currently loaded items only<span></span></label>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleClickOptionRadio} >OK</button>
                                <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Cancel</button>
                            </div>
                            <div class="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.contextConfigs !== null &&
                    this.state.contextConfigs.contextCount > 0 &&
                    <div style={{ height: '5%', border: '0px solid #111' }}>
                        <h4 className="labelContext" style={contextStyles.rightFontscontext}>Context Navigator </h4>

                        {
                            this.props.cacheState === true &&
                            <span onClick={this.refresContext.bind(this)} style={{ marginLeft: '200px', float: 'right' }} >
                                <UpdateWorkplace />
                            </span>
                        }
                        {
                            this.props.contextExpandCollapse === true &&
                            <span style={{ marginLeft: '320px', cursor: 'pointer', marginTop: '-30px', float: 'left' }} id="expand" onClick={this.closeContext}>
                                <ExpandContext />
                            </span>
                        }
                        {
                            this.props.contextExpandCollapse === false &&
                            <span style={{ marginLeft: '320px', cursor: 'pointer', marginTop: '-30px', float: 'left' }} id="collapse" onClick={this.openContext}>
                                {/*< SvgContextPanelCollapse />*/}
                                <CollapseContext />

                            </span>
                        }

                    </div>

                }
                {
                    this.state.contextConfigs !== null &&
                    this.state.contextConfigs.contextCount > 0 &&
                    options.length > 1 &&

                    <div style={{ border: '0px solid #111'  }} className="dropdownContext">
                        <ul onClick={this.openDropdown} onChange={this.changeContextTemplate.bind(this)} className="dropbtnContext">{selectedContext.contextTemplate.name}</ul>
                        <div id="myDropdownContext" className="dropdown-content-context" >
                            {/*<option className="changeContext"  >Change context</option>*/}

                            {
                                this.state.contextConfigs !== null &&
                                options
                            }


                        </div>
                    </div>

                }
                {
                    this.state.contextConfigs !== null &&
                    this.state.contextConfigs.contextCount > 0 &&
                    <div className="contextHeight" style={{ border: '1px solid #111', scrollbarWidth: '30px', border: '1px', borderColor: '#111111' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', color: '#555' }} >
                            <input
                                //style={{ fontSize: '13px', color: '#555 !Important', paddingRight: '12px', paddingLeft: '12px' }}
                                onKeyPress={this.handleClick}
                                id="inputContext"
                                placeholder="Search..."
                                type="text" value={this.state.contextsearch} onChange={this.handleChange}
                            />
                            {/*<i onClick={this.handleClick} className="glyphicon glyphicon-search" style={{ marginLeft: '13px', fontSize: '15px', fontWeight: '700', color:'#4d4d4dd1' }} ></i>*/}

                        </div>
                    </div>
                }

             
                <div  style={{ marginTop: '7px', overflowX: overflowX, overflowY: overflow,  border: '0px solid #111', fontSize: '13px', scrollbarWidth: '30px', color: 'red !important', marginLeft: '25px', width: widthContext, paddingLeft: '3.3px' }}>

                    {

                        this.state.contextConfigs !== null && this.state.contextConfigs.contextCount > 0  &&
                            arraymulticontext.length > 0 ?
                            //[...this.props.myList].reverse().map(createListItem, this)
                            arraymulticontext.reverse().map((i, idx) => {
                            
                                return <TreeView
                                    
                                    id={idx == 0 ? 'selection-treeview' : 'selection-treeviewMulti'}
                                    // id={'selection-treeview' : 'sel}
                                    useNativeScrolling={true}
                                    showScrollbar="always"
                                    onItemRendered={this.itemrender}
                                    height={'auto'}
                                    //items={this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].displayTree}
                                    items={i.context}

                                    showCheckBoxesMode={'normal'}
                                    selectionMode={this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].contextStructure.selectionType === 1
                                        || this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].contextStructure.selectionType === '1'
                                        ? 'single' : 'multiple'}
                                    //selectionMode={'multiple'}
                                    AllowCheckNodes={true}
                                    AllowSelectNode={true}
                                    onItemSelectionChanged={this.onContextSelected}
                                    
                                    keyExpr={'nokeys'}
                                    onItemClick={this.getNextLevel}
                                    ref={idx == 0 ? this.treeRef : this.treeRefMulti}
                                    onContentReady={this.onContentReady}
                                />
                            }) : this.state.contextConfigs !== null && this.state.contextConfigs.contextCount > 0 && this.props.multirootContext !== true && 
                            <TreeView
                                style={{ paddingBottom: paddingBottom }}
                                id={'selection-treeview'}
                                onItemRendered={this.itemrender}
                                items={treeObject}
                                useNativeScrolling={true}
                                showScrollbar="always"
                                showCheckBoxesMode={'normal'}
                                selectionMode={this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].contextStructure.selectionType === 1
                                    || this.state.contextConfigs.contextTemplateInfos[this.state.currentContextIdx].contextStructuresAndRelations[0].contextStructure.selectionType === '1'
                                    ? 'single' : 'multiple'}
                                AllowCheckNodes={true}
                                AllowSelectNode={true}
                                onItemSelectionChanged={this.onContextSelected}
                              
                                keyExpr={'nokeys'}
                                onItemClick={this.getNextLevel}
                                ref={this.treeRef}
                                onContentReady={this.onContentReady}
                            />
                            //: this.props.multirootContext === true && <span style={{ fontSize: '16px', marginTop: '20px', marginLeft: '-5px' }}>Context List is not supported</span>
                    }

                </div>
                {/*<p style={{ height: '8%' }} className="contextBottomlogo"  ><Ulylogo /></p>*/}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        taskIdState: state.taskDataId,
        folderIdState: state.folderDataId,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        themeState: state.currentThemeName,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        contextExpandCollapse: state.currContextExpandCollapse,
        cacheState: state.currCacheState,
        rootContextState: state.rootContext,
        multirootContext: state.currentActionmultiroot,
        contextConfig: state.currentContextConfiguration,

    }
};
const mapDispatchToProps = dispatch => {
    return {
        contextTemplateIdSet: payload => dispatch(setContextTemplateIdAction(payload)),
        contextSelectionSet: payload => dispatch(setSelectedContextItemsAction(payload)),
        contextSelectionIdSet: payload => dispatch(setSelectedContextId(payload)),
        contextConfigurationSet: payload => dispatch(setContextConfigurationAction(payload)),
        contextExpandCollapseSet: payload => dispatch(setContextsExpandCollapse(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        rootContextSet: payload => dispatch(setRootContextID(payload)),
        rootSelectedSet: payload => dispatch(setActionisrootSelected(payload)),
        multiRootContextItemsSet: payload => dispatch(setActionMultiRootContextItems(payload)),


    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Context);



// WEBPACK FOOTER //
// ./src/components/TaskView/SideDraw/Context/Context.js